import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import { Box, Button, Grid, InputLabel, MenuItem, Modal, Typography, Select } from '@mui/material';
import { Textarea } from '../../../../../../components';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'white',
  border: '0px solid #000',
  boxShadow: 24,
  borderRadius: 5,
  p: 5,
};

function TermsAndConditionDisableUserModal({
  isOpen,
  handleClose,
  onDisableUser,
  info,
  eventList,
}) {
  const [allowDisableUser, setAllowDisableUser] = useState(false);
  const [message, setMessage] = useState('');
  const [eventId, setEventId] = useState(null);
  const [showMessageFieldsRequired, setShowMessageFieldsRequired] = useState(false);

  const handleChange = (event) => {
    setEventId(event.target.value);
  };

  function getFullName() {
    const { name, last_name: lastName } = info.user;
    return (
      <b>
        {name} {lastName}
      </b>
    );
  }

  useEffect(() => {
    if (eventList.length > 0) setAllowDisableUser(true);
    else setAllowDisableUser(false);
  }, [eventList.length]);

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h5" component="h5">
          Violation of terms and conditions
        </Typography>
        <Grid container marginLeft={1} marginTop={3}>
          <Grid item sm={11}>
            {allowDisableUser ? (
              <Typography variant="body">
                The user {getFullName()} has violated the terms and conditions of the event in which
                he is registered. This user will be disabled.
              </Typography>
            ) : (
              <div style={{ background: '#0997ba', padding: 15, borderRadius: 15 }}>
                <Typography variant="body" color="white">
                  The user {getFullName()}
                  <b style={{ color: 'rgb(9 58 81)' }}> does not have any associated event, </b>
                  therefore it cannot be disabled due to violation of terms and conditions.
                </Typography>
              </div>
            )}
          </Grid>
          <Grid sm={11} marginTop={2}>
            <FormControl sx={{ m: 1, width: '98%' }} size="small">
              <InputLabel id="demo-select-small">Event</InputLabel>
              <Select
                disabled={!allowDisableUser}
                labelId="demo-select-small"
                id="demo-select-small"
                value={eventId}
                label="Event"
                onChange={handleChange}>
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {eventList.map(({ event }) => (
                  <MenuItem key={event.id} value={event.id}>
                    {event.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item sm={10} marginTop={3}>
            <Textarea
              type="text"
              name="description"
              placeholder="Type the reason why this user violated the terms and conditions..."
              value={message}
              disabled={!allowDisableUser}
              onChange={(e) => setMessage(e.target.value)}
            />
          </Grid>
          {showMessageFieldsRequired && (
            <Grid item sm={10}>
              <Typography color="red" textAlign="start">
                * Event and message are required fields.
              </Typography>
            </Grid>
          )}
          {allowDisableUser}
          {allowDisableUser && (
            <Grid item sm={11} marginTop={3}>
              <Typography variant="body">
                A message SMS will be sent to the user notifying that he has violated the terms and
                conditions of the event.
              </Typography>
            </Grid>
          )}

          <Grid item sm={12}>
            <Grid container justifyContent="space-evenly" marginTop={3}>
              <Grid>
                <Button
                  onClick={() => handleClose()}
                  size="large"
                  variant="outlined"
                  color="inherit"
                  style={{ borderRadius: 20 }}>
                  Cancel
                </Button>
              </Grid>
              <Grid>
                <Button
                  disabled={!allowDisableUser}
                  onClick={() => {
                    if (eventId && message.trim() !== '') {
                      onDisableUser(eventId, message);
                      setShowMessageFieldsRequired(false);
                    } else {
                      setShowMessageFieldsRequired(true);
                    }
                  }}
                  size="large"
                  variant="contained"
                  color="primary"
                  style={{ borderRadius: 20 }}>
                  Disable user
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

TermsAndConditionDisableUserModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onDisableUser: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  info: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  eventList: PropTypes.any.isRequired,
};

export default TermsAndConditionDisableUserModal;
